import { NgModule } from '@angular/core'

import { RequestInterceptorService } from './request-interceptor/request-interceptor.service'
// palmyra-needle-angular-import-feature-policy: Do not delete this line
import { VariableincomePolicyService } from '@features/variableincome/policy/variableincome-policy.service'

@NgModule({
  providers: [
    RequestInterceptorService,
    // palmyra-needle-angular-provide-feature-policy: Do not delete this line
    {
      provide: 'VariableincomePolicyService',
      useClass: VariableincomePolicyService,
    },
  ],
})
export class CoreServicesModule {}
